import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Result, Spin, Tabs, Tag, Typography } from 'antd';
import { ReloadOutlined, ShopOutlined } from '@ant-design/icons';
import AylikRapor from './AylikRapor';
import Gorusmeler from './Gorusmeler';
import HaftalikPlan from './HaftalikPlan';
import InsaatGecis from './InsaatGecis';
import { hata, useSatisApi } from './ortak';
import '../ortak/nfmodules.css';

/**
 * Satış Süreci (26.10.2026) — /satis-sureci. Görüşmeler | Haftalık Plan | Aylık Rapor | İnşaata Geçiş.
 * Erişim backend'de (routes/satis_sureci.py): `Genel / Satış Süreci` r/w VEYA keşif ekibi üyeliği — pozisyonu
 * olmayan saha personeli de girebilsin diye rota PermissionBasedRoute'a tip/anahtar ile BAĞLANMAZ; 403'te
 * erişim yok ekranı gösterilir.
 */
const { Title } = Typography;
const SEKME_ANAHTARI = 'satisSureciSekme';

const okuSekme = () => {
  try {
    return localStorage.getItem(SEKME_ANAHTARI) || 'gorusme';
  } catch {
    return 'gorusme';
  }
};

export default function SatisSureciPage() {
  const api = useSatisApi();
  const [erisim, setErisim] = useState(null);
  const [secenek, setSecenek] = useState(null);
  const [hataMesaji, setHataMesaji] = useState(null); // {durum: 403 | diğer, metin}
  const [sekme, setSekme] = useState(okuSekme);

  const secenekleriYukle = useCallback(() => api.get('/secenekler').then(setSecenek), [api]);
  // 27.10 düzeltmesi: yalnız 403 "Erişim yok"; ağ / 500 / 503 hatası yetkili kullanıcıya yetkisiz gibi görünmesin
  const baslat = useCallback(() => {
    setHataMesaji(null);
    api.get('/erisim')
      .then((e) => { setErisim(e); return secenekleriYukle(); })
      .catch((e) => setHataMesaji({ durum: e?.response?.status, metin: hata(e) }));
  }, [api, secenekleriYukle]);
  useEffect(() => { baslat(); }, [baslat]);

  const sekmeDegis = (k) => {
    setSekme(k);
    try { localStorage.setItem(SEKME_ANAHTARI, k); } catch { /* gizli pencere */ }
  };

  if (hataMesaji?.durum === 403) return <Result status="403" title="Erişim yok" subTitle={hataMesaji.metin} />;
  if (hataMesaji) {
    return (
      <Result status="error" title="Satış Süreci yüklenemedi" subTitle={hataMesaji.metin}
        extra={<Button type="primary" icon={<ReloadOutlined />} onClick={baslat}>Yeniden dene</Button>} />
    );
  }
  if (!erisim || !secenek) return <div style={{ padding: 48, textAlign: 'center' }}><Spin /></div>;

  const ortak = { api, erisim, secenek };
  const sekmeler = [
    { key: 'gorusme', label: 'Görüşmeler', children: <Gorusmeler {...ortak} /> },
    { key: 'haftalik', label: 'Haftalık Plan', children: <HaftalikPlan {...ortak} onEkipDegisti={secenekleriYukle} /> },
    { key: 'aylik', label: 'Aylık Rapor', children: <AylikRapor {...ortak} /> },
    { key: 'insaat', label: 'İnşaata Geçiş', children: <InsaatGecis {...ortak} /> },
  ];

  return (
    <div className="nf-module satis-sayfa">
      <style>{`
        .satis-sayfa .ant-tabs-nav { margin-bottom: 12px; }
        .satis-sayfa .ant-segmented { max-width: 100%; overflow-x: auto; }
        @media (max-width: 575px) { .nf-module.satis-sayfa { padding: 8px; } }
      `}</style>
      <Title level={3} style={{ marginTop: 0 }}>
        <ShopOutlined style={{ marginRight: 8 }} />Satış Süreci
        {erisim.uye && <Tag color="blue" style={{ marginLeft: 12, verticalAlign: 'middle' }}>Keşif ekibi</Tag>}
        {!erisim.yazma && <Tag style={{ marginLeft: 8, verticalAlign: 'middle' }}>Salt okunur</Tag>}
      </Title>
      {erisim.kurulum_eksik?.length > 0 && (
        <Alert type="error" showIcon style={{ marginBottom: 12 }} message="Veritabanı güncellemesi uygulanmamış"
          description={`scripts/migrate_satis_sureci.py çalıştırılmalı (eksik: ${erisim.kurulum_eksik.join(', ')}). Raporlar çalışır, görüşme ve plan kaydı açılamaz.`} />
      )}
      <Tabs activeKey={sekme} onChange={sekmeDegis}
        items={sekmeler.map((s) => ({ key: s.key, label: s.label, children: s.key === sekme ? s.children : null }))} />
    </div>
  );
}
